import React, { Component } from 'react';
import { Card, Icon, Avatar, message, Input, Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import WarehouseModal from '../../components/modals/WarehouseModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Warehouses extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.schema = {name: '', branch_id: 1};
    this.state = {redirect: false, warehouses: [], filteredWarehouses: [], modalVisible: false, current: this.schema, handleSave: this.handleCreate};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getWarehouses = this.getWarehouses.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getWarehouses();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getWarehouses() {
    axios.get(`${Configuration.apiServer}/api/v1/warehouses`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({warehouses: resp.data, filteredWarehouses: resp.data});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/warehouses/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getWarehouses();
    });
  }

  handleSearch(event) {
    const warehouses = this.state.warehouses.filter(warehouse => {
      return warehouse.name.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredWarehouses: warehouses});
  }

  handleOpenModal(kind, record) {
    if(kind === 'new') {
      this.setState({modalVisible: true, current: this.schema, handleSave: this.handleCreate});
    } else {
      this.setState({modalVisible: true, current: record, handleSave: this.handleUpdate});
    }
  }

  handleCloseModal() {
    this.setState({modalVisible: false});
  }

  handleCreate(record) {
    axios.post(`${Configuration.apiServer}/api/v1/warehouses`, {warehouse: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getWarehouses();
      this.setState({modalVisible: false});
      message.success('Registro guardado');
    });
  }

  handleUpdate(record) {
    axios.put(`${Configuration.apiServer}/api/v1/warehouses/${this.state.current.id}`, {warehouse: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.getWarehouses();
      this.setState({modalVisible: false});
      message.success('Registro actualizado');
    });
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // List of warehouses
    const warehouses = this.state.filteredWarehouses.map(warehouse => {
      return (
        <Col md={6} style={{marginBottom: "15px"}}>
          <Card
            actions={[<a href={`/admin/warehouses/${warehouse.id}`}><Icon type="eye" /></a>, <Icon type="edit" onClick={() => { this.handleOpenModal('edit', warehouse) }} />]}
            key={warehouse.id}
          >
            <Meta
              avatar={<Avatar icon="solution" />}
              title={warehouse.name}
              description={<span className={`cursor text-${Configuration.getStatus(warehouse.status).color}`} onClick={() => { this.handleStatus(warehouse.id) }}>{Configuration.getStatus(warehouse.status).text}</span>}
            />
            <p className="text-muted" style={{ marginBottom: '0px', marginLeft: '45px', marginTop: '5px' }}>En sucursal {warehouse.branch.name}</p>
          </Card>
        </Col>
      );
    });

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Almacenes</h3>
            <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '30%' }} />
          </div>

          <br/>

          <Row gutter={16}>
            {warehouses}
          </Row>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />

        <WarehouseModal visible={this.state.modalVisible} title={"Nuevo almacén"} current={this.state.current} handleClose={this.handleCloseModal} handleSave={this.state.handleSave} />
      </div>
    );
  }
}

export default Warehouses;



// WEBPACK FOOTER //
// ./src/pages/admin/Warehouses.js